import { useRef, useEffect, useState } from "react";

const TICKER_TEXT =
  "Technology Movement Pakistan (TMP) congratulates all newly elected office bearers on their successful election. We wish them every success in serving the party and the nation. Official assumption of responsibilities: 22.06.2026.";

export default function Ticker() {
  const trackRef = useRef(null);
  const [paused, setPaused] = useState(false);

  // Dynamically duplicate text so the loop is seamless regardless of viewport
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const clone = track.querySelector(".ticker-item").cloneNode(true);
    track.appendChild(clone);
  }, []);

  return (
    <div
      className="tmp-ticker"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      {/* Label chip */}
      <div className="tmp-ticker__label">
        <span className="tmp-ticker__dot" />
        LIVE
      </div>

      {/* Scrolling track */}
      <div className="tmp-ticker__viewport">
        <div
          ref={trackRef}
          className={`tmp-ticker__track${paused ? " tmp-ticker__track--paused" : ""}`}
        >
          <span className="ticker-item">
            <span className="tmp-ticker__divider">★</span>
            {TICKER_TEXT}
            <span className="tmp-ticker__divider">★</span>
          </span>
        </div>
      </div>
    </div>
  );
}
